// src/components/CategoryRedirectHandler.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGeneralInfoStore } from '../stores/GeneralInfoStore';
import { tilesData, useTranslatedTilesData } from '../config/tilesConfig';
import { categoryTabs } from '../config/categoryTabsCofig';

const CategoryRedirectHandler: React.FC = () => {
  const navigate = useNavigate();
  const { setCategory, setActiveTab, setCurrentPage } = useGeneralInfoStore();
  const translatedTiles = useTranslatedTilesData();

  useEffect(() => {
    const currentPath = window.location.pathname.replace('/', '');

    // Skip if this looks like a page path (starts with uppercase or contains certain patterns)
    if (currentPath.match(/^[A-Z]/) || currentPath.includes('Smart') || currentPath === '') {
      return;
    }

    // Convert tab name to URL format (same function as in AppRoutes)
    const urlToTabName = (name: string): string => {
      return name
        .toLowerCase()
        .replace(/[äöüß]/g, (match) => {
          const map: Record<string, string> = { ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' };
          return map[match] || match;
        })
        .replace(/[^a-z0-9]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    };

    // Find which tab this URL corresponds to by checking all tabs in categoryTabs
    let foundTab = null;
    let foundCategory = '';

    for (const [categoryKey, tabs] of Object.entries(categoryTabs)) {
      for (const tab of tabs) {
        if (urlToTabName(tab.name) === currentPath) {
          foundTab = tab;
          foundCategory = categoryKey;
          break;
        }
      }
      if (foundTab) break;
    }

    if (foundTab && foundCategory) {

      // Find the tile to navigate to using the tab's defaultTileId
      const defaultTile = tilesData.find(tile => tile.id === foundTab.defaultTileId);
      if (defaultTile) {
        // Find the translated tile to get the correct title
        const translatedTile = translatedTiles.find(tile => tile.id === defaultTile.id);
        const pageTitle = translatedTile ? translatedTile.title : defaultTile.titleKey;

        // Set the store values
        setCategory(foundCategory);
        setActiveTab(foundTab.name);
        setCurrentPage(pageTitle);


        navigate(defaultTile.navigateTo, { replace: true });
      } else {
        navigate('/NotFound', { replace: true });
      }
    } else {
      navigate('/NotFound', { replace: true });
    }

  }, [navigate, setCategory, setActiveTab, setCurrentPage, translatedTiles]);

  return <div>Redirecting...</div>;
};

export default CategoryRedirectHandler;